// extracted by mini-css-extract-plugin
module.exports = {"menu":"sidebar-menu_menu__mq5UO","show":"sidebar-menu_show__3PVYC"};